<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card title="Hesap" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img
                :src="
                  user_data.avatar ? user_data.avatar : this.$defaultPicture
                "
                class="rounded w-full"
              />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Adı Soyadı</td>
                <td>{{ user_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ user_data.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Durumu</td>
                <td>{{ user_data.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Role</td>
                <td>{{ user_data.role }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Departman</td>
                <td>{{ user_data.company }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div
            class="vx-col justify-end w-full flex"
            id="account-manage-buttons"
          >
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{
                name: 'userEdit',
                params: { userId: $route.params.userId }
              }"
              >Düzenle</vs-button
            >
            <!-- <vs-button
              color="dark"
              icon-pack="feather"
              icon="icon-user-x"
              class="mr-4"
              @click="confirmHireRecord"
              >İşten Çıkar</vs-button
            > -->

          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Bilgi" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Doğum Tarihi</td>
                <td>{{ user_data.dob }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Telefon</td>
                <td>{{ user_data.phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Diller</td>
                <td>{{ user_data.languages_known }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Cinsiyet</td>
                <td>{{ user_data.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">TC NO</td>
                <td>{{ user_data.contact_options }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Adres</td>
                <td>{{ user_data.contact_options }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Departman" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">İşe Başlama Tarihi:</td>
                <td>{{ user_data.createdDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mesai Saatleri</td>
                <td></td>
              </tr>
              <tr>
                <td class="font-semibold">Maaş Bilgisi</td>
                <td></td>
              </tr>
              <tr>
                <td class="font-semibold">İzin Hakkı</td>
                <td></td>
              </tr>
              <tr>
                <td class="font-semibold">Avans Hakkı</td>
                <td></td>
              </tr>
              <tr>
                <td class="font-semibold">NitroCOIN</td>
                <td></td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
      
          <vx-card>
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">İzinler</span>
            </div>
            <vs-divider />

            <div class="block overflow-x-auto">
              <table class="w-full permissions-table">
                <tr>
                  <th
                    class="font-semibold text-base text-left px-3 py-2"
                    v-for="heading in [
                      'Birim',
                      'Okuma',
                      'Yazma',
                      'Oluşturma',
                      'Silme'
                    ]"
                    :key="heading">
                    {{ heading }}
                  </th>
                </tr>
                <tr v-for="row in sampleData" :key="row.name">
                  <td class="px-3 py-2">{{ row.name }}</td>
                  <td
                    v-for="(value, index) in row.val"
                    class="px-3 py-2"
                    :key="index"                  >
                    <vs-checkbox v-model="value[index]"></vs-checkbox>
                  </td>
                </tr>
              </table>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  data() {
    return {
      user_data: {},
      user_not_found: false,
      sampleData: [
        { name: "Teknik", val: ["ass", "1", "true", "000"] },
        {
          name: "Personel",
          val: ["false", "2", "1", "000"]
        },
        {
          name: "Stok",
          val: ["true", "false", "1", "000"]
        }
      ]
    };
  },
  computed: {
    userAddress() {
      let str = "";
      for (var field in this.user_data.location) {
        str += field + " ";
      }
      return str;
    }
  },
  methods: {
    confirmHireRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `İşten Çıkar`,
        text: `"${this.user_data.name}" işten çıkartmak istediğinize emin misiniz?`,
        accept: this.hireRecord,
        acceptText: "Çıkar",
        cancelText: "Vazgeç"
      });
    },
    hireRecord() {
      console.warn(this.user_data.status);
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Silme İşlemi`,
        text: `"${this.user_data.name}" Silmek istediğinize emin misiniz?`,
        accept: this.deleteRecord,
        acceptText: "Sil",
        cancelText: "Vazgeç"
      });
    },
    deleteRecord: async function() {
      repository.deleteEntity("User/deleteUser", this.user_data.uId);
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Personel Silindi",
        text: `"${this.user_data.name}" Başarıyla silindi.`
      });
    }
  },
  created() {
    const userId = this.$route.params.userId;

    repository
      .getById("User/getUser", userId)
      .then(r => (this.user_data = r.entity));
  }
};
</script>

<style lang="scss" scoped>
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
